import React from "react";

function TermsAndConditions() {
  return (
    <div
      style={{
        background: "#f4f6fb",
        minHeight: "100vh",
        paddingBottom: 80,
      }}
    >
      <div
        style={{
          maxWidth: 1100,
          margin: "0 auto",
          padding: "80px 20px 0",
        }}
      >
        <section
          style={{
            background: "#fff",
            borderRadius: 32,
            padding: "60px 40px",
            boxShadow: "0 40px 120px rgba(15,23,42,0.15)",
            border: "1px solid rgba(99,102,241,0.15)",
          }}
        >
          <p
            style={{
              textTransform: "uppercase",
              letterSpacing: 4,
              fontWeight: 600,
              color: "#6366f1",
              fontSize: 14,
              marginBottom: 8,
            }}
          >
            Terms & Conditions
          </p>
          <h1
            style={{
              fontSize: 46,
              fontWeight: 900,
              marginTop: 12,
              color: "#0f172a",
            }}
          >
            EventNova Terms & Conditions
          </h1>
          <p
            style={{
              marginTop: 12,
              fontSize: 16,
              color: "#64748b",
            }}
          >
            Last Updated: 20/November/2025
          </p>
          <p
            style={{
              marginTop: 18,
              fontSize: 18,
              color: "#475569",
              lineHeight: 1.8,
            }}
          >
            These Terms and Conditions ("Terms") govern your access to and use of the EventNova platform ("EventNova," "we," "our," or "the Platform"). By creating an account, subscribing, advertising, or using any features on EventNova, you ("User," "Vendor," or "Subscriber") agree to be bound by these Terms.
          </p>
          <p
            style={{
              marginTop: 16,
              fontSize: 18,
              color: "#475569",
              lineHeight: 1.8,
              fontWeight: 600,
            }}
          >
            If you do not agree, you must discontinue use of the Platform immediately.
          </p>
        </section>

        <section style={{ marginTop: 50 }}>
          <div
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.9)",
              boxShadow: "0 20px 60px rgba(15,23,42,0.08)",
              marginBottom: 32,
            }}
          >
            <h2
              style={{
                fontSize: 26,
                fontWeight: 800,
                color: "#0f172a",
                marginBottom: 20,
              }}
            >
              Overview of Services
            </h2>
            <p
              style={{
                color: "#475569",
                lineHeight: 1.7,
                marginBottom: 16,
                fontSize: 16,
              }}
            >
              EventNova is a digital discovery platform that enables users to find, explore, and contact event service providers ("Vendors"). EventNova does not:
            </p>
            <ul
              style={{
                marginTop: 12,
                paddingLeft: 20,
                color: "#334155",
                lineHeight: 1.6,
                fontSize: 16,
              }}
            >
              <li style={{ marginBottom: 8 }}>Handle or facilitate bookings</li>
              <li style={{ marginBottom: 8 }}>Process payments for services between users and vendors</li>
              <li style={{ marginBottom: 8 }}>Guarantee vendor performance, pricing, or availability</li>
              <li style={{ marginBottom: 8 }}>Engage in disputes between customers and vendors</li>
            </ul>
            <p
              style={{
                color: "#475569",
                lineHeight: 1.7,
                marginTop: 16,
                fontSize: 16,
              }}
            >
              All transactions, discussions, and agreements between users and vendors occur outside the EventNova platform.
            </p>
          </div>

          <div
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.9)",
              boxShadow: "0 20px 60px rgba(15,23,42,0.08)",
              marginBottom: 32,
            }}
          >
            <h2
              style={{
                fontSize: 26,
                fontWeight: 800,
                color: "#0f172a",
                marginBottom: 20,
              }}
            >
              Vendor Accounts and Subscriptions
            </h2>

            <h3
              style={{
                fontSize: 20,
                fontWeight: 700,
                color: "#0f172a",
                marginTop: 24,
                marginBottom: 12,
              }}
            >
              Eligibility
            </h3>
            <p
              style={{
                color: "#475569",
                lineHeight: 1.7,
                marginBottom: 12,
                fontSize: 16,
              }}
            >
              To create a vendor account or subscribe to paid plans, you must:
            </p>
            <ul
              style={{
                marginTop: 12,
                paddingLeft: 20,
                color: "#334155",
                lineHeight: 1.6,
                fontSize: 16,
              }}
            >
              <li style={{ marginBottom: 8 }}>Be at least 18 years old;</li>
              <li style={{ marginBottom: 8 }}>Provide accurate business information;</li>
              <li style={{ marginBottom: 8 }}>Have legal authority to represent your business.</li>
            </ul>

            <h3
              style={{
                fontSize: 20,
                fontWeight: 700,
                color: "#0f172a",
                marginTop: 28,
                marginBottom: 12,
              }}
            >
              Subscription Plans
            </h3>
            <p
              style={{
                color: "#475569",
                lineHeight: 1.7,
                marginBottom: 12,
                fontSize: 16,
              }}
            >
              Vendors may subscribe to monthly, quarterly, or annual plans. Subscription benefits include:
            </p>
            <ul
              style={{
                marginTop: 12,
                paddingLeft: 20,
                color: "#334155",
                lineHeight: 1.6,
                fontSize: 16,
              }}
            >
              <li style={{ marginBottom: 8 }}>Profile listing</li>
              <li style={{ marginBottom: 8 }}>Visibility enhancements</li>
              <li style={{ marginBottom: 8 }}>Access to promotional tools</li>
              <li style={{ marginBottom: 8 }}>Optional paid advertising features</li>
            </ul>

            <h3
              style={{
                fontSize: 20,
                fontWeight: 700,
                color: "#0f172a",
                marginTop: 28,
                marginBottom: 12,
              }}
            >
              Non-transferability
            </h3>
            <p
              style={{
                color: "#475569",
                lineHeight: 1.7,
                fontSize: 16,
              }}
            >
              Vendor accounts and subscriptions are non-transferable and may not be shared or resold.
            </p>

            <h3
              style={{
                fontSize: 20,
                fontWeight: 700,
                color: "#0f172a",
                marginTop: 28,
                marginBottom: 12,
              }}
            >
              Account Suspension
            </h3>
            <p
              style={{
                color: "#475569",
                lineHeight: 1.7,
                marginBottom: 12,
                fontSize: 16,
              }}
            >
              EventNova may suspend or terminate any vendor account for:
            </p>
            <ul
              style={{
                marginTop: 12,
                paddingLeft: 20,
                color: "#334155",
                lineHeight: 1.6,
                fontSize: 16,
              }}
            >
              <li style={{ marginBottom: 8 }}>Fraudulent activity</li>
              <li style={{ marginBottom: 8 }}>Misrepresentation</li>
              <li style={{ marginBottom: 8 }}>Violation of platform rules</li>
              <li style={{ marginBottom: 8 }}>Abuse or misconduct toward users or staff</li>
              <li style={{ marginBottom: 8 }}>Non-payment of subscription fees</li>
            </ul>
          </div>

          <div
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.9)",
              boxShadow: "0 20px 60px rgba(15,23,42,0.08)",
              marginBottom: 32,
            }}
          >
            <h2
              style={{
                fontSize: 26,
                fontWeight: 800,
                color: "#0f172a",
                marginBottom: 20,
              }}
            >
              Payments, Billing & Refund Policy
            </h2>

            <h3
              style={{
                fontSize: 20,
                fontWeight: 700,
                color: "#0f172a",
                marginTop: 24,
                marginBottom: 12,
              }}
            >
              Payment Responsibility
            </h3>
            <p
              style={{
                color: "#475569",
                lineHeight: 1.7,
                fontSize: 16,
              }}
            >
              Vendors are responsible for all fees associated with their subscription or advertising purchases.
            </p>

            <h3
              style={{
                fontSize: 20,
                fontWeight: 700,
                color: "#0f172a",
                marginTop: 28,
                marginBottom: 12,
              }}
            >
              Non-Refundable Fees
            </h3>
            <p
              style={{
                color: "#475569",
                lineHeight: 1.7,
                marginBottom: 12,
                fontSize: 16,
              }}
            >
              All payments for:
            </p>
            <ul
              style={{
                marginTop: 12,
                paddingLeft: 20,
                color: "#334155",
                lineHeight: 1.6,
                fontSize: 16,
              }}
            >
              <li style={{ marginBottom: 8 }}>Subscription plans</li>
              <li style={{ marginBottom: 8 }}>Featured listings</li>
              <li style={{ marginBottom: 8 }}>Sponsored ads</li>
              <li style={{ marginBottom: 8 }}>Promotional placements</li>
            </ul>
            <p
              style={{
                color: "#475569",
                lineHeight: 1.7,
                marginTop: 12,
                fontSize: 16,
              }}
            >
              are strictly non-refundable, as access to services is granted immediately upon payment.
            </p>

            <h3
              style={{
                fontSize: 20,
                fontWeight: 700,
                color: "#0f172a",
                marginTop: 28,
                marginBottom: 12,
              }}
            >
              Refund Exceptions
            </h3>
            <p
              style={{
                color: "#475569",
                lineHeight: 1.7,
                marginBottom: 12,
                fontSize: 16,
              }}
            >
              Refunds will only be considered if:
            </p>
            <ul
              style={{
                marginTop: 12,
                paddingLeft: 20,
                color: "#334155",
                lineHeight: 1.6,
                fontSize: 16,
              }}
            >
              <li style={{ marginBottom: 8 }}>A duplicate charge occurred</li>
              <li style={{ marginBottom: 8 }}>A technical system error caused incorrect billing</li>
              <li style={{ marginBottom: 8 }}>The vendor could not access the platform due to a verified EventNova malfunction</li>
            </ul>
            <p
              style={{
                color: "#475569",
                lineHeight: 1.7,
                marginTop: 12,
                fontSize: 16,
              }}
            >
              All refund requests must be submitted within 7 days of payment.
            </p>

            <h3
              style={{
                fontSize: 20,
                fontWeight: 700,
                color: "#0f172a",
                marginTop: 28,
                marginBottom: 12,
              }}
            >
              Billing Issues
            </h3>
            <p
              style={{
                color: "#475569",
                lineHeight: 1.7,
                fontSize: 16,
              }}
            >
              EventNova is not responsible for payment delays, bank errors, or gateway processing timelines.
            </p>
          </div>

          <div
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.9)",
              boxShadow: "0 20px 60px rgba(15,23,42,0.08)",
              marginBottom: 32,
            }}
          >
            <h2
              style={{
                fontSize: 26,
                fontWeight: 800,
                color: "#0f172a",
                marginBottom: 20,
              }}
            >
              Platform Use & Vendor Obligations
            </h2>

            <h3
              style={{
                fontSize: 20,
                fontWeight: 700,
                color: "#0f172a",
                marginTop: 24,
                marginBottom: 12,
              }}
            >
              Accuracy of Information
            </h3>
            <p
              style={{
                color: "#475569",
                lineHeight: 1.7,
                fontSize: 16,
              }}
            >
              Vendors must ensure all information displayed on their profiles including pricing, service descriptions, images, and contact details is accurate and lawful.
            </p>

            <h3
              style={{
                fontSize: 20,
                fontWeight: 700,
                color: "#0f172a",
                marginTop: 28,
                marginBottom: 12,
              }}
            >
              Vendor–User Interactions
            </h3>
            <p
              style={{
                color: "#475569",
                lineHeight: 1.7,
                marginBottom: 12,
                fontSize: 16,
              }}
            >
              All service negotiations, pricing, transactions, and agreements take place directly between vendors and customers. EventNova bears no responsibility for:
            </p>
            <ul
              style={{
                marginTop: 12,
                paddingLeft: 20,
                color: "#334155",
                lineHeight: 1.6,
                fontSize: 16,
              }}
            >
              <li style={{ marginBottom: 8 }}>Service quality</li>
              <li style={{ marginBottom: 8 }}>Delivery timelines</li>
              <li style={{ marginBottom: 8 }}>Disputes or claims</li>
              <li style={{ marginBottom: 8 }}>Cancellations or failures by either party</li>
            </ul>

            <h3
              style={{
                fontSize: 20,
                fontWeight: 700,
                color: "#0f172a",
                marginTop: 28,
                marginBottom: 12,
              }}
            >
              Prohibited Actions
            </h3>
            <p
              style={{
                color: "#475569",
                lineHeight: 1.7,
                marginBottom: 12,
                fontSize: 16,
              }}
            >
              Vendors and users may not:
            </p>
            <ul
              style={{
                marginTop: 12,
                paddingLeft: 20,
                color: "#334155",
                lineHeight: 1.6,
                fontSize: 16,
              }}
            >
              <li style={{ marginBottom: 8 }}>Post misleading or fraudulent content</li>
              <li style={{ marginBottom: 8 }}>Upload harmful files or unauthorized images</li>
              <li style={{ marginBottom: 8 }}>Harass or abuse other users</li>
              <li style={{ marginBottom: 8 }}>Attempt to scrape, hack, or damage the platform</li>
              <li style={{ marginBottom: 8 }}>Use EventNova for illegal activities</li>
            </ul>
          </div>

          <div
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.9)",
              boxShadow: "0 20px 60px rgba(15,23,42,0.08)",
              marginBottom: 32,
            }}
          >
            <h2
              style={{
                fontSize: 26,
                fontWeight: 800,
                color: "#0f172a",
                marginBottom: 20,
              }}
            >
              Platform Content & Intellectual Property
            </h2>

            <h3
              style={{
                fontSize: 20,
                fontWeight: 700,
                color: "#0f172a",
                marginTop: 24,
                marginBottom: 12,
              }}
            >
              Ownership
            </h3>
            <p
              style={{
                color: "#475569",
                lineHeight: 1.7,
                fontSize: 16,
              }}
            >
              All platform content including logos, design, systems, data structures, and branding is the exclusive property of EventNova and may not be copied or reproduced without permission.
            </p>

            <h3
              style={{
                fontSize: 20,
                fontWeight: 700,
                color: "#0f172a",
                marginTop: 28,
                marginBottom: 12,
              }}
            >
              Vendor Content License
            </h3>
            <p
              style={{
                color: "#475569",
                lineHeight: 1.7,
                marginBottom: 12,
                fontSize: 16,
              }}
            >
              By uploading content, vendors grant EventNova a non-exclusive, royalty-free license to:
            </p>
            <ul
              style={{
                marginTop: 12,
                paddingLeft: 20,
                color: "#334155",
                lineHeight: 1.6,
                fontSize: 16,
              }}
            >
              <li style={{ marginBottom: 8 }}>Display their content</li>
              <li style={{ marginBottom: 8 }}>Promote their listings</li>
              <li style={{ marginBottom: 8 }}>Use images for marketing the platform (if permitted)</li>
            </ul>
            <p
              style={{
                color: "#475569",
                lineHeight: 1.7,
                marginTop: 12,
                fontSize: 16,
              }}
            >
              You retain all ownership of your business content.
            </p>
          </div>

          <div
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.9)",
              boxShadow: "0 20px 60px rgba(15,23,42,0.08)",
              marginBottom: 32,
            }}
          >
            <h2
              style={{
                fontSize: 26,
                fontWeight: 800,
                color: "#0f172a",
                marginBottom: 20,
              }}
            >
              Limitation of Liability
            </h2>
            <p
              style={{
                color: "#475569",
                lineHeight: 1.7,
                marginBottom: 12,
                fontSize: 16,
              }}
            >
              To the fullest extent permitted by law, EventNova is not liable for:
            </p>
            <ul
              style={{
                marginTop: 12,
                paddingLeft: 20,
                color: "#334155",
                lineHeight: 1.6,
                fontSize: 16,
              }}
            >
              <li style={{ marginBottom: 8 }}>Losses arising from customer–vendor interactions</li>
              <li style={{ marginBottom: 8 }}>Service failures, delays, or cancellations</li>
              <li style={{ marginBottom: 8 }}>Financial transactions conducted outside the platform</li>
              <li style={{ marginBottom: 8 }}>Damages resulting from inaccurate vendor information</li>
              <li style={{ marginBottom: 8 }}>Downtime, maintenance, or technical issues</li>
              <li style={{ marginBottom: 8 }}>Indirect, incidental, or consequential damages of any kind</li>
            </ul>
            <p
              style={{
                color: "#475569",
                lineHeight: 1.7,
                marginTop: 16,
                fontSize: 16,
              }}
            >
              EventNova provides the platform "as is" without warranties of any kind.
            </p>
          </div>

          <div
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.9)",
              boxShadow: "0 20px 60px rgba(15,23,42,0.08)",
              marginBottom: 32,
            }}
          >
            <h2
              style={{
                fontSize: 26,
                fontWeight: 800,
                color: "#0f172a",
                marginBottom: 20,
              }}
            >
              Indemnification
            </h2>
            <p
              style={{
                color: "#475569",
                lineHeight: 1.7,
                marginBottom: 12,
                fontSize: 16,
              }}
            >
              You agree to indemnify and hold EventNova harmless from all claims, damages, liabilities, and expenses arising from:
            </p>
            <ul
              style={{
                marginTop: 12,
                paddingLeft: 20,
                color: "#334155",
                lineHeight: 1.6,
                fontSize: 16,
              }}
            >
              <li style={{ marginBottom: 8 }}>Your use of the platform</li>
              <li style={{ marginBottom: 8 }}>Your interactions with customers</li>
              <li style={{ marginBottom: 8 }}>Your content or business practices</li>
              <li style={{ marginBottom: 8 }}>Any breach of these Terms</li>
            </ul>
          </div>

          <div
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.9)",
              boxShadow: "0 20px 60px rgba(15,23,42,0.08)",
              marginBottom: 32,
            }}
          >
            <h2
              style={{
                fontSize: 26,
                fontWeight: 800,
                color: "#0f172a",
                marginBottom: 20,
              }}
            >
              Modifications to Terms
            </h2>
            <p
              style={{
                color: "#475569",
                lineHeight: 1.7,
                fontSize: 16,
              }}
            >
              EventNova may update or modify these Terms at any time. Continued use of the platform after changes constitutes acceptance of the updated Terms.
            </p>
          </div>

          <div
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.9)",
              boxShadow: "0 20px 60px rgba(15,23,42,0.08)",
              marginBottom: 32,
            }}
          >
            <h2
              style={{
                fontSize: 26,
                fontWeight: 800,
                color: "#0f172a",
                marginBottom: 20,
              }}
            >
              Governing Law
            </h2>
            <p
              style={{
                color: "#475569",
                lineHeight: 1.7,
                fontSize: 16,
              }}
            >
              These Terms are governed by the laws of the Federal Republic of Nigeria. Any disputes will be resolved in Nigerian courts with appropriate jurisdiction.
            </p>
          </div>

          <section
            style={{
              marginTop: 50,
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.9)",
              boxShadow: "0 20px 60px rgba(15,23,42,0.08)",
            }}
          >
            <h2
              style={{
                fontSize: 26,
                fontWeight: 800,
                color: "#0f172a",
                marginBottom: 20,
              }}
            >
              Contact Information
            </h2>
            <p style={{ color: "#475569", lineHeight: 1.8, marginBottom: 0, fontSize: 16 }}>
              For inquiries, support, or legal concerns, contact:{" "}
              <a
                href="mailto:info@eventnova.com.ng"
                style={{ color: "#6366f1", textDecoration: "underline" }}
              >
                info@eventnova.com.ng
              </a>
            </p>
          </section>
        </section>
      </div>
    </div>
  );
}

export default TermsAndConditions;
